/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
    DeleteProject: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.DeleteProjectAction.REQUEST_DELETEPROJECT:
      return {
        ...state
      };
    case actions.DeleteProjectAction.DELETEPROJECT_RECEIVED:
      return {
        ...state,
        DeleteProject: action.data
      };

    default:
      return state;
  }
};

export default reducer;
